import {useCallback, useEffect, useState} from "react";
import {useOutletContext} from "react-router";
import {Paper, Typography, useTheme} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {apiGet} from "../utils";
import {buildLegacyAuditUrl, hasDateFilters} from "../utils/filters";
import {fetchProfitDriversAnalysis} from "../utils/profitDrivers";
import {ProfitDriversPanel} from "../components/ProfitDriversPanel";
import {ProfitLeaksPanel} from "../components/ProfitLeaksPanel";
import {MarginProfilePanel} from "../components/MarginProfilePanel";
import {PricingHealthPanel} from "../components/PricingHealthPanel";
import {PricingHealthDetailChart} from "../components/PricingHealthDetailChart";
import {TopBottomPerformancePanel} from "../components/TopBottomPerformancePanel";
import {LoadingPanel} from "../utils/loading_spinner";
import {useMemo} from "react";

export const AuditProfileContainer = () => {
    const {filters} = useOutletContext();
    const theme = useTheme();

    // eslint-disable-next-line
    const [profileData, setProfileData] = useState(null);
    const [profitDriversData, setProfitDriversData] = useState(null);
    const [profitDetailData, setProfitDetailData] = useState({ products: [], customers: [], salesReps: [] });
    const [loading, setLoading] = useState(false);
    const [selectedPricingMetric, setSelectedPricingMetric] = useState('costPassThruRate');

    const fetchAuditProfile = useCallback(() => {
        if (!hasDateFilters(filters)) return;

        setLoading(true);
        fetchProfitDriversAnalysis(filters, (data) => {
            setProfitDriversData(data);
            setLoading(false);
        });
    }, [filters]);

    const fetchDetailData = useCallback(() => {
        if (!hasDateFilters(filters)) return;

        setLoading(true);
        apiGet(buildLegacyAuditUrl('profile/profit_detail', filters), (resp) => {
            if (resp.success) {
                // setProfileData(resp.data);
                setProfitDetailData(resp.data)
            } else {
                console.error('Audit Profile API error:', resp.error);
            }
            setLoading(false);
        });
    }, [filters]);

    useEffect(() => {
        fetchAuditProfile();
    }, [fetchAuditProfile]);

    useEffect(() => {
        fetchDetailData();
    }, [fetchDetailData]);

    const isEmptyProfileData = useMemo(() => {
        if (profitDriversData) return false;
        return true;
    }, [profitDriversData])

    if (loading) {
        return <LoadingPanel loading={true} message="Loading audit profile..." />;
    }

    if (isEmptyProfileData) {
        return (
            <Paper style={{ ...theme.palette.contentPanel, padding: 40, textAlign: 'center', margin: 30 }}>
                <Typography>No audit profile data available</Typography>
            </Paper>
        );
    }

    return (
        <div style={{ marginTop: 30, marginBottom: 100, marginLeft: 30, marginRight: 30 }}>
            <Grid container spacing={2}>

                {/* Profit Drivers - minimal=false */}
                <Grid size={4}>
                    <ProfitDriversPanel data={profitDriversData} />
                </Grid>

                {/* Margin Profile */}
                <Grid size={4}>
                    <MarginProfilePanel data={profileData?.marginProfile} />
                </Grid>

                {/* Pricing Health */}
                <Grid size={4}>
                    <PricingHealthPanel
                        data={profileData?.pricingHealth}
                        selectedMetric={selectedPricingMetric}
                        onMetricClick={setSelectedPricingMetric}
                    />
                </Grid>
            </Grid>

            <Grid container spacing={2}>

                {/* Profit Leaks - minimal=false */}
                <Grid size={4}>
                    <ProfitLeaksPanel />
                </Grid>

                {/* Top/Bottom */}
                <Grid size={4}>
                    <TopBottomPerformancePanel detailData={profitDetailData || {}} />
                </Grid>

                {/* Pricing Detail */}
                <Grid size={4}>
                    <PricingHealthDetailChart selectedMetric={selectedPricingMetric} />
                </Grid>
            </Grid>
            
        </div>
    );
};